module.exports = __webpack_public_path__ + "img/RyanM.f328c03f.jpg";